if (process.env.REACT_APP_SHOW_I18N_VIZ === 'true') {
  module.exports.withI18nViz = require('./withI18nViz').default;
} else {
  module.exports.withI18nViz = function (mapVizProps) {
    return function (I18nComponent) {
      return I18nComponent;
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../lib/index.js
// module id = 10
// module chunks = 0